(() => {
  const state = window.koppaStockState;
  if (!state?.cartHasPreorderDetails) return;
  const handles = new Set(['ghk-cu-moisturizer', 'ghk-cu-trio']);
  const legacy = item => handles.has(item.handle) && (
    /pre[ -]?order/i.test(item.properties?.['Order type'] || '') ||
    /3[–-]4 weeks|inventory arrives|when.*cream.*ready/i.test(item.properties?.Dispatch || '')
  );
  const request = async (path, body) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
      credentials: 'same-origin',
      headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
      ...(body ? {method: 'POST', body: JSON.stringify(body)} : {})
    });
    if (!response.ok) throw new Error('Unable to update order details');
    return response.json();
  };
  const update = async () => {
    let cart = await request('cart.js');
    let changed = false;
    for (let i = 0; i < 20; i++) {
      const item = cart.items.find(legacy);
      if (!item) break;
      const properties = {...item.properties};
      if ('Order type' in properties) properties['Order type'] = state.labels.standardOrder;
      if ('Dispatch' in properties) properties.Dispatch = state.labels.inStockDispatch;
      if ('Fulfillment' in properties) properties.Fulfillment = state.labels.standardFulfillment;
      if ('Dispatch together' in properties) properties['Dispatch together'] = state.labels.completeSet;
      cart = await request('cart/change.js', {id: item.key, quantity: item.quantity, properties});
      changed = true;
    }
    if (changed) await window.KoppaCartConversion?.refresh();
  };
  let finished = false;
  const ready = update().catch(error => console.warn('Koppā order details:', error.message)).finally(() => { finished = true; });
  document.addEventListener('click', event => {
    const checkout = event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (!checkout || finished) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ready.then(() => checkout.click());
  }, true);
})();
